"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSlrLoggingBody = void 0;
const createSlrLoggingBody = (phone_number, type, ssoConfiguration) => {
    return Object.assign({ phone_number: phone_number, from_screen: `${window["Screen"]}`, screen: window["gtmPrevScreen"], action: window["gtmLastAction"], type }, ssoConfiguration);
};
exports.createSlrLoggingBody = createSlrLoggingBody;
